import { IdName } from './Generics/IdName.model';

export class SegmentEmployeeFind implements IdName {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    id: any;
    name: string;
    systemName: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(id: any, name: string, systemName: string) {
        this.id = id;
        this.name = name;
        this.systemName = systemName;
    }
}
